// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1NVDs","topBottomGutter":"Layout_topBottomGutter__S95r3"};